import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "member_details_body"
};
const _hoisted_2 = {
  style: {
    "position": "relative",
    "overflow": "hidden"
  }
};
const _hoisted_3 = {
  style: {
    "text-align": "center",
    "margin-bottom": "50px",
    "margin-top": "20px"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "width": "100%"
  }
};
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h1", null, _toDisplayString($setup.get_data.title), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", {
    class: "html",
    innerHTML: $setup.get_data.text,
    style: {
      "margin-bottom": "100px"
    }
  }, null, 8, _hoisted_5)])])]);
}